import { Vue, Component } from 'vue-property-decorator';
import { sanitizeRedirectPath } from '@/utils/sanitizeRedirectPath';

@Component
export default class BaseLogin extends Vue {
  /**
   * 로그인 완료 후 화면을 이동한다.
   * @param redirectUrl 이동할 경로. 기본값은 redirectUrl 쿼리
   */
  protected async redirectAfterLogin(redirectUrl: string = this.$route.query?.redirectUrl?.toString() ?? '') {
    const continuePath = sanitizeRedirectPath(redirectUrl);

    if (await this.redirectToSmsMigrationIfNeeded(continuePath)) {
      return;
    }

    this.$router.push(continuePath);
  }

  /**
   * 홈('/') 진입 시 SMS 마이그레이션이 필요한 몰이 있으면 안내 쿼리와 함께 이동한다.
   * @returns 이동했으면 true
   */
  protected async redirectToSmsMigrationIfNeeded(redirectUrl: string): Promise<boolean> {
    const { path, query, hash } = this.$router.resolve(redirectUrl).route;

    if (path && path !== '/') {
      return false;
    }

    try {
      const [migrationStatus, reminderStatus] = await Promise.all([
        this.getSmsManageMigrationsStatus(),
        this.getSmsManagersReminderStatus()
      ]);

      const shouldMigrate = !migrationStatus.migrated && migrationStatus.migrationRequired;
      const mallNeededToMigrate = reminderStatus.malls.find(({ hasOldSendNo, hasResponsibilityManager }: { hasOldSendNo: boolean; hasResponsibilityManager: boolean }) => hasOldSendNo && (!hasResponsibilityManager || shouldMigrate));

      if (mallNeededToMigrate) {
        this.$router.push({
          path,
          query: {
            ...query,
            continueAction: reminderStatus.isRepresentativeAdmin ? 'redirectToSmsMigration' : 'alertSmsMigration',
            ...(reminderStatus.isRepresentativeAdmin ? { mallNo: mallNeededToMigrate.mallNo } : undefined)
          },
          hash,
        });
        return true;
      }
    } catch (err) {
      console.error(err);
    }

    return false;
  }

  async getSmsManageMigrationsStatus() {
    const { data } = await this.$commerceApi.axios.get('/sms/manage/migrations/status');

    return data;
  }

  async getSmsManagersReminderStatus() {
    const { data } = await this.$api.axios.get('/sms/managers/reminder-status');

    return data;
  }
}
